import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const campaignApi = createApi({
    reducerPath: 'campaignApi',
    baseQuery: fetchBaseQuery({
        baseUrl: `${process.env.REACT_APP_BACKEND_HOST}/api`,
        prepareHeaders: (headers) => {
            const token = localStorage.getItem('prona_userToken');
            if (token) {
                headers.set("Authorization", `Bearer ${token}`);
            }
            return headers;
        },
    }),
    tagTypes: ['Campaigns', 'Campaign', 'CampaignListings', 'PerformanceReport'],
    endpoints: (build) => ({
        getCampaigns: build.query({
            query(params = {}) {
                return {
                    url: '/campaigns',
                    params: params,
                    method: 'GET',
                    headers: {}
                }
            },
            providesTags: ['Campaigns'],
            transformResponse: (response) => response.data
        }),
        getCampaignById: build.query({
            query(id) {
                return {
                    url: `/campaigns/${id}`,
                    method: 'GET',
                    headers: {}
                }
            },
            providesTags: (result, error, id) => [{ type: 'Campaign', id }],
            transformResponse: (response) => response.data
        }),
        createCampaign: build.mutation({
            query(data) {
                return {
                    url: '/campaigns',
                    method: 'POST',
                    body: data,
                    headers: {}
                }
            },
            invalidatesTags: ['Campaigns']
        }),
        updateCampaign: build.mutation({
            query({ id, ...data }) {
                return {
                    url: `/campaigns/${id}`,
                    method: 'PUT',
                    body: data,
                    headers: {}
                }
            },
            invalidatesTags: (result, error, { id }) => [
                'Campaigns',
                { type: 'Campaign', id }
            ]
        }),
        deleteCampaign: build.mutation({
            query(id) {
                return {
                    url: `/campaigns/${id}`,
                    method: 'DELETE',
                    headers: {}
                }
            },
            invalidatesTags: ['Campaigns']
        }),
        getCampaignListings: build.query({
            query(campaignId) {
                return {
                    url: `/campaigns/${campaignId}/listings`,
                    method: 'GET',
                    headers: {}
                }
            },
            providesTags: (result, error, campaignId) => [
                { type: 'CampaignListings', id: campaignId }
            ],
            transformResponse: (response) => response.data
        }),
        addListingToCampaign: build.mutation({
            query({ campaignId, listing_id, position }) {
                return {
                    url: `/campaigns/${campaignId}/listings`,
                    method: 'POST',
                    body: { listing_id, position },
                    headers: {}
                }
            },
            invalidatesTags: (result, error, { campaignId }) => [
                { type: 'CampaignListings', id: campaignId },
                { type: 'Campaign', id: campaignId },
                'Campaigns'
            ]
        }),
        removeListingFromCampaign: build.mutation({
            query({ campaignId, listingId }) {
                return {
                    url: `/campaigns/${campaignId}/listings/${listingId}`,
                    method: 'DELETE',
                    headers: {}
                }
            },
            invalidatesTags: (result, error, { campaignId }) => [
                { type: 'CampaignListings', id: campaignId },
                { type: 'Campaign', id: campaignId },
                'Campaigns'
            ]
        }),
        getCampaignPerformanceReport: build.query({
            query() {
                return {
                    url: '/campaigns/reports/performance',
                    method: 'GET',
                    headers: {}
                }
            },
            providesTags: ['PerformanceReport'],
            transformResponse: (response) => response.data
        })
    })
});

export const {
    useGetCampaignsQuery,
    useGetCampaignByIdQuery,
    useCreateCampaignMutation,
    useUpdateCampaignMutation,
    useDeleteCampaignMutation,
    useGetCampaignListingsQuery,
    useAddListingToCampaignMutation,
    useRemoveListingFromCampaignMutation,
    useGetCampaignPerformanceReportQuery
} = campaignApi;
